<template>
  <!-- 待办任务 -->
  <div style="position: relative;">
    <el-form ref="formMyTask"  style="margin:5px 0" :model="formMyTask" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350" operatorPosition='start'>
        <el-form-item label="流水号" prop="serialNo">
          <el-input class="filter-item" v-model="formMyTask.formFilter.serialNo" :clearable="true" placeholder="流水号"/>  
        </el-form-item>
        <el-form-item label="流程名称" prop="formFilter.processDefinitionName">
          <el-select class="filter-item"  v-model="formMyTask.formFilter.processDefinitionName" placeholder="流程名称" clearable>
            <el-option-group
              v-for="group in options"
              :key="group.processDefinitionKey"
              :label="group.processDefinitionName">
              <el-option
                v-for="item in group.children"
                :key="item.processDefinitionKey"
                :label="item.processDefinitionName"
                :value="item.processDefinitionName">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="当前任务" prop="formFilter.taskName">
          <el-input class="filter-item" v-model="formMyTask.formFilter.taskName"
            :clearable="true" placeholder="当前任务" />
        </el-form-item>
        <el-form-item label="工程名称/文号" prop="formFilter.runName">
          <el-input class="filter-item"
            v-model="formMyTask.formFilter.runName"
            :clearable="true" placeholder="工程名称/文号"
          />
        </el-form-item>
        <el-form-item label="工程名称" prop="formFilter.gcmc">
          <el-select style="width:100%" filterable  :clearable="true" v-model="formMyTask.formFilter.gcmc" placeholder="工程名称">
            <el-option
              v-for="item in projectList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同名称" prop="formFilter.htmc">
          <el-select style="width:100%" filterable  :clearable="true" v-model="formMyTask.formFilter.htmc" placeholder="合同名称">
            <el-option
              v-for="item in contractList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <div  style="margin: 0 0 15px 30px">
          <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="handleSearch">查询</el-button>
          <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        </div>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="flowEntry" :data="formMyTask.taskWidget.dataList" :size="defaultFormItemSize" @sort-change="formMyTask.taskWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="流水号" prop="serialNo" width="130px"  />
          <el-table-column label="流程名称" prop="processDefinitionName" width="200px" />
          <el-table-column label="文号" prop="runName" />
          <el-table-column label="当前任务" prop="taskName" width="200px"  />
          <el-table-column label="发起时间" prop="processInstanceStartTime"  width="200px" />
          <el-table-column label="状态" width="200px" >
            <template slot-scope="scope">
               <span style="color:rgb(0, 128, 0)">处理中</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"  width="150px">
            <template slot-scope="scope">
              <el-button class="table-btn" :size="defaultFormItemSize" type="text" @click="getFlow(scope.row)">流程图</el-button>
              <el-button class="table-btn primary" :size="defaultFormItemSize" type="text" @click="onSubmit(scope.row)">办理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="formMyTask.taskWidget.totalCount"
            :current-page="formMyTask.taskWidget.currentPage"
            :page-size="formMyTask.taskWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="formMyTask.taskWidget.onCurrentPageChange"
            @size-change="formMyTask.taskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :visible="visible"
       width="1000px"
       top='5vh'
       :before-close="onClose"
    >
      <formTaskProcessViewer v-if="visible"  :flag="false"  :processDefinitionId='record.processDefinitionId'  :processInstanceId='record.processInstanceId' />
    </el-dialog>
    
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';
import formTaskProcessViewer from "./formTaskProcessViewer";
import { OnlineOperation } from '@/api/onlineController.js';

export default {
  name: 'formMyTask',
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  components:{
    formTaskProcessViewer
  },
  props:{
    options:{
      type :Array,
      default : () => []
    }
  },
  data () {
    return {
      formMyTask: {
        formFilter: {
          processDefinitionName: undefined,
          processDefinitionKey: undefined,
          taskName: undefined,
          runName: undefined,
          serialNo: undefined,
          gcmc: undefined,
          htmc: undefined
        },
        formFilterCopy: {
          processDefinitionName: undefined,
          processDefinitionKey: undefined,
          taskName: undefined,
          runName: undefined,
          serialNo: undefined,
          gcmc: undefined,
          htmc: undefined
        },
        taskWidget: new TableWidget(this.loadTaskData, this.loadTaskDataVerify, true, false, 'entryId', false,null,localStorage.getItem('page') ? JSON.parse(localStorage.getItem('page')).pageParam.pageNum : 1),
        isInit: false
      },
      record:{},
      visible:false,
      projectList:[],
      contractList:[]
    }
  },
  created() {
    this.init()
    const row = JSON.parse(localStorage.getItem('task'))
    if (row) {
      this.onSubmit(row)
    }
    const search = JSON.parse(localStorage.getItem('search'))
    if (search) {
      this.formMyTask.formFilter = search
      this.formMyTask.formFilterCopy = search
    }
  },
  mounted() {
    localStorage.removeItem('page')
  },
  methods: {
    handleSearch(){
      this.refreshMyTask(true)
      localStorage.removeItem('page')
    },
    init(){
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res=>{
        this.projectList = res.data
      })
      OnlineOperation.listDict(this, {
        dictId: '1684463201976061952'
      }).then(res=>{
        this.contractList = res.data
      })
    },
    onReset () {
      this.formMyTask.formFilter.serialNo= ''
      this.formMyTask.formFilterCopy.serialNo= ''
      this.formMyTask.formFilter.gcmc= ''
      this.formMyTask.formFilterCopy.gcmc= ''
      this.formMyTask.formFilter.htmc= ''
      this.formMyTask.formFilterCopy.htmc= ''
      this.formMyTask.formFilter.taskName= ''
      this.formMyTask.formFilterCopy.taskName= ''
      this.formMyTask.formFilter.processDefinitionName= ''
      this.formMyTask.formFilterCopy.processDefinitionName= ''
      this.refreshMyTask(true);
    },
    loadTaskData (params) {
      if (params == null) params = {};
      if(params.pageParam.pageNum !== 1) {
        localStorage.setItem('page',JSON.stringify({pageParam:params.pageParam}))
      } else {
        localStorage.removeItem('page')
      }
      params = {
        processDefinitionName: this.formMyTask.formFilterCopy.processDefinitionName,
        processDefinitionKey: this.formMyTask.formFilterCopy.processDefinitionKey,
        taskName: this.formMyTask.formFilterCopy.taskName,
        runName: this.formMyTask.formFilterCopy.runName,
        serialNo: this.formMyTask.formFilterCopy.serialNo,
        gcmc: this.formMyTask.formFilterCopy.gcmc,
        htmc: this.formMyTask.formFilterCopy.htmc,
        ...params
      }
      return new Promise((resolve, reject) => {
        FlowOperationController.listRuntimeTask(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTaskDataVerify () {
      this.formMyTask.formFilterCopy.processDefinitionName = this.formMyTask.formFilter.processDefinitionName;
      this.formMyTask.formFilterCopy.processDefinitionKey = this.formMyTask.formFilter.processDefinitionKey;
      this.formMyTask.formFilterCopy.serialNo = this.formMyTask.formFilter.serialNo;
      this.formMyTask.formFilterCopy.taskName = this.formMyTask.formFilter.taskName;
      this.formMyTask.formFilterCopy.runName = this.formMyTask.formFilter.runName;
      this.formMyTask.formFilterCopy.gcmc = this.formMyTask.formFilter.gcmc;
      this.formMyTask.formFilterCopy.htmc = this.formMyTask.formFilter.htmc;
      return true;
    },
    onSubmit (row) {
      localStorage.setItem('task',JSON.stringify(row))
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: row.taskId
      }
      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          console.log(row);
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              taskId: row.taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: row.taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              // 过滤掉加签操作，加签只有在已完成任务里可以操作
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList,
              flowStatus:'未办结',
              form: true,
              serialNo: row.serialNo
            }
          });
        }
      }).catch(e => {});
    },
    refreshMyTask (reloadData = false) {
      if (reloadData) {
        this.formMyTask.taskWidget.refreshTable(true, 1);
      } else {
        this.formMyTask.taskWidget.refreshTable();
      }
      localStorage.setItem('search',JSON.stringify(this.formMyTask.formFilterCopy))
    },
    onResume () {
      this.refreshMyTask();
    },
    formInit () {
      this.refreshMyTask();
    },
    // 查看流程图
    getFlow(record){
      this.record = record
      this.visible = true
    },
    onClose(){
      this.visible = false
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style>
</style>
